import { h, FunctionComponent } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import MainImage from './MainImage';
import Carousel from './Carousel';
import ZoomView from './ZoomView';
import { Image } from '../types';

const ProductImage: FunctionComponent<ProductImageProps> = ({
    productName,
    images,
    zoomed,
    imagesFull,
    embeds,
    defaultColour
}) => {
    const [selectedColour, setSelectedColour] = useState<string>(defaultColour);
    const [showZoomView, setShowZoomView] = useState<boolean>(false);

    const selectColour = (colour: string) => {
        setSelectedColour(colour);
    };

    const activeImages = images.filter(i => i.colour === selectedColour);
    const activeImagesFull = imagesFull.filter(i => i.colour === selectedColour);

    return (
        <>
            <MainImage
                images={activeImages}
                imagesFull={activeImagesFull}
                onShowZoomView={() => {
                    setShowZoomView(true);
                }}
            />
            {showZoomView ? (
                <ZoomView
                    productName={productName}
                    images={zoomed}
                    selectedColour={selectedColour}
                    selectColour={selectColour}
                    onClose={() => setShowZoomView(false)}
                />
            ) : null}
            <Carousel images={images} selectedColour={selectedColour} onSelect={selectColour} />
        </>
    );
};

interface ProductImageProps {
    productName: string;
    images: Image[];
    zoomed: Image[];
    imagesFull: Image[];
    embeds: Image[] | null;
    defaultColour: string;
}

export default ProductImage;
